const Heading = {
  variants: {
    h2: {
      as: 'h2',
      fontSize: '1.75rem',
      fontWeight: '700',
    },
    statTitle: {
      as: 'h3',
      fontSize: '1.5rem',
      fontWeight: '700',
    },
    statValue: {
      as: 'h3',
      fontSize: '2.5rem',
      color: 'brand.primary',
      fontWeight: '700',
    },
  },
}
export default Heading
